import type { WidgetProps } from '@rjsf/utils';
import { TextField } from '@mui/material';
import type { ReactElement } from 'react';

export function TextareaWidget({
  id,
  value,
  readonly,
  disabled,
  autofocus,
  onBlur,
  onFocus,
  onChange,
  options,
  rawErrors = [],
  placeholder,
}: WidgetProps): ReactElement {
  return (
    <TextField
      id={id}
      value={value ?? ''}
      disabled={disabled}
      autoFocus={autofocus}
      placeholder={placeholder}
      error={rawErrors.length > 0}
      onChange={({ target: { value: v } }) => onChange(v === '' ? options.emptyValue : v)}
      onBlur={({ target: { value: v } }) => onBlur(id, v)}
      onFocus={({ target: { value: v } }) => onFocus(id, v)}
      fullWidth
      multiline
      rows={(options.rows as number) || 5}
      inputProps={{ readOnly: readonly }}
    />
  );
}
